import React from "react"
import classes from "./Shared.module.scss"

const reservations = (props) => {
  return (
    <a className={[classes.resComp, classes[props.addClass], classes[props.addClass2], classes[props.addClass3]].join(' ')} 
      href="https://tables.toasttab.com/restaurants/320f9992-f800-4066-9e19-bc19d582dbcc/findTime" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      {props.text ? props.text : "Reservations"}
    </a>
  )
}
export default reservations